// extracted by mini-css-extract-plugin
module.exports = {"name":"Sidebar_name__1puf7","btnWrapper":"Sidebar_btnWrapper__9lSuC","wrapper":"Sidebar_wrapper__kXPv6","closeIcon":"Sidebar_closeIcon__2UqD5"};